/* ==========================================================================
   SearcherFlight > Client > Discount > Panel
   ========================================================================== */

/* Modules */
const { html } = require('common-tags');
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');

const TooltipTemplate = require('@bluekiri/alexandria-contrib-components/components/tooltip/template');
const Tooltip = require('@bluekiri/alexandria-contrib-components/components/tooltip/client/js');

const ButtonTemplate = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/template');
const Button = require('@bluekiri/alexandria-contrib-components/components/button-rxjs/client/js');

const { fromEvent, of } = require('rxjs');
const { take, filter, mergeAll } = require('rxjs/operators');

const { addData, addStyle } = require('@bluekiri/alexandria/helpers/dataHelpers');

const { renderBonus, initBonus, destroyBonus } = require('./bonus');
const { renderResident, initResident, destroyResident } = require('./resident');

const configuration = require('../../config');

/* Render footer */
const renderFooter = literals => {
    const { closePanelLabel = '' } = literals;

    const button = ButtonTemplate(
        addStyle(
            addData(
                {
                    content: closePanelLabel
                },
                { type: configuration().type.acceptButton }
            ),
            [configuration().css.actionButton]
        )
    );

    return html(`
        <div class='footer'>
            ${button}
        </div>
    `);
};

/* Create */
function createPanel(instance) {
    /* Data */
    const { context, literals } = instance.config;

    /* Template */
    const template = TooltipTemplate(
        addData(
            {
                content: html(`
                        ${renderResident(instance)}
                        ${renderBonus(instance)}
                        ${renderFooter(literals)}
                    `),
                negative: false,
                placement: 'bottom-end'
            },
            {
                type: configuration().type.discount
            }
        ),
        context
    );

    /* Node */
    const node = toNode(template)[0];

    /* Return */
    return node;
}

/* Add */
function addPanel(instance, trigger) {
    const panel = instance;

    /* Node */
    const node = createPanel(instance);

    /* Add */
    instance.element.appendChild(node);

    /* Reference */
    panel.discountPanel = Tooltip(`[data-component='Tooltip'][data-type=${configuration().type.discount}]`, {
        trigger
    });

    panel.tooltipAcceptDiscountButton = Button(
        `[data-type=${configuration().type.discount}] 
        [data-component='ButtonRxjs'][data-type='${configuration().type.acceptButton}']`
    );

    /* Init */
    fromEvent(node, 'transitionend')
        .pipe(take(1))
        .subscribe(() => {
            /* Resident */
            initResident(instance);

            /* Bonus */
            initBonus(instance);

            /* Subscriptions */
            panel.subscriptions = {
                ...instance.subscriptions,
                closeDiscountPanel: of(fromEvent(document, 'click'), fromEvent(window, 'keydown'))
                    .pipe(
                        mergeAll(),
                        filter(event => !!instance.discountPanel || event.keyCode === 27),
                        filter(() => !instance.discountModal),
                        filter(
                            event =>
                                !event.target.closest('[data-component=Tooltip]') ||
                                event.target === panel.tooltipAcceptDiscountButton.element
                        ),
                        take(1)
                    )
                    .subscribe(() => {
                        /* Remove */
                        destroyPanel(instance);
                    })
            };
        });

    /* Visible */
    setTimeout(() => node.classList.add(configuration().css.visible), 50);
}

/* Remove */
function destroyPanel(instance) {
    const panel = instance;

    /* Element */
    const { element } = instance.discountPanel;

    if (!instance.discountPanel) {
        return;
    }

    fromEvent(element, 'transitionend')
        .pipe(take(1))
        .subscribe(() => {
            /* Bonus */
            destroyBonus(instance);

            /* Resident */
            destroyResident(instance);

            /* Button */
            panel.tooltipAcceptDiscountButton.actions.destroy();
            delete panel.tooltipAcceptDiscountButton;

            /* Reference */
            instance.discountPanel.actions.destroy();
            delete panel.discountPanel;
        });

    /* Visible */
    setTimeout(() => element.classList.remove(configuration().css.visible), 50);
}

module.exports = {
    addPanel,
    destroyPanel
};
